import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { selectInsuranceInfo } from '../../redux-state/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_INSURANCE_INFO } from '../../redux-state/forms/types';

function InsuranceInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(false);
  const insuranceInfo = useSelector(selectInsuranceInfo);
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_INSURANCE_INFO,
      payload: { key, value },
    });
  };

  return (
    <div>
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">Insurance Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Hide Detail' : 'Show Detail'}</div>
          <FormControlLabel
            control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
          />
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Insurance Company"
              variant="outlined"
              fullWidth
              value={insuranceInfo?.insuranceCompany}
              onChange={(e) => handleChange('insuranceCompany', e.target.value)}
            />
            <TextField
              label="Insurance Date"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={insuranceInfo?.insuranceDate}
              onChange={(e) => handleChange('insuranceDate', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Insurance Expiration Date"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={insuranceInfo?.insuranceExpirationDate}
              onChange={(e) => handleChange('insuranceExpirationDate', e.target.value)}
            />
            <TextField
              label="Insurance Policy Number"
              variant="outlined"
              fullWidth
              value={insuranceInfo?.insurancePolicyNumber}
              onChange={(e) => handleChange('insurancePolicyNumber', e.target.value)}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default InsuranceInformation;
